jQuery(document).ready(function ($) {
    $('.wp-block-theme-name-read-more').each(function () {
        const $block = $(this);
        const $content = $block.find('> .read-more-content');
        const $button = $block.find('> .read-more-button');

        $content.css('--initial-height', $content.data('initialHeight') + 'px');

        $button.on('click', function () {
            const isExpanded = $content.toggleClass('expanded').hasClass('expanded');
            const readLessText = $button.data('readLessText');
            const readMoreText = $button.data('readMoreText');

            if (isExpanded) {
                $button.text(readLessText).addClass('expanded');
            } else {
                $button.text(readMoreText).removeClass('expanded');

                if ($(window).scrollTop() > $block.offset().top) {
                    $('html, body').animate({
                        scrollTop: $block.offset().top - 50
                    }, 500);
                }
            }
        });
    });
});